import { render } from "./ContentOptionsSelector.vue?vue&type=template&id=df234aaa&ts=true"
import script from "./ContentOptionsSelector.vue?vue&type=script&lang=ts"
export * from "./ContentOptionsSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__